const messages = {
  en: {
    subject: "Subject",
    active: "Active",
    questionNumber: "Questions number",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    hidden: "hidden",
    active1: "active",
    approved: "approved",
    declined: "declined",
    pending: "pending"
  },
  ru: {
      subject: "Subject",
      active: "Активный",
      questionNumber: "Количество вопросов",
      edit: "Править",
      delete: "Удалить",
      save: "Сохранить",
      hidden: "скрытый",
      active1: "aктивный",
      approved: "одобренный",
      declined: "отклоненный",
      pending: "в ожидании"
  }
};

export default messages;